import { Heading } from '@circlefin/components'
import useTranslation from 'next-translate/useTranslation'

import { FormattedWalletAddress } from '../../../../components'
import { ConnectRecipientWallet } from '../../../../containers'

import type { BlockchainAbbreviation } from '@shared/graphql'

export interface ReceiveDisconnectedProps {
  /**
   * Wallet address.
   */
  address?: string
  /**
   * Chain.
   */
  chain?: BlockchainAbbreviation
  /**
   * Wallet description.
   */
  description?: string
}

export const ReceiveDisconnected: React.FC<ReceiveDisconnectedProps> = ({
  address,
  chain,
  description,
}) => {
  const { t } = useTranslation('ace')

  return (
    <>
      <Heading
        alignment="center"
        iconName="ExclamationSolid"
        layout="vertical"
        status="warning"
        variant="page/sm"
      >
        <Heading.Header as="h2">
          {t(`sendOnchain.receive.disconnected.heading`)}
        </Heading.Header>
        <Heading.Intro as="p">
          {t(`sendOnchain.receive.disconnected.subheading`)}
        </Heading.Intro>
      </Heading>

      {address && chain != null && (
        <div className="m-auto mt-12 w-128">
          <FormattedWalletAddress
            address={address}
            chain={chain}
            heading={t(`sendOnchain.receive.connectedWalletLabel`)}
            walletName={description ?? undefined}
          />

          <div className="border-t border-black-50">
            <ConnectRecipientWallet
              address={address}
              chain={chain}
              label={t('sendOnchain.receive.connectedWalletLabel')}
            />
          </div>
        </div>
      )}
    </>
  )
}
